import type {
  PublicContactMethodChannel,
  PublicContactMethodKind,
  PublicContactMethodResponse,
} from "../../../../../../../../../api/public/appointment-portal"

export type ContactMethodStatusPresentation = {
  label: string
  color: "green" | "neutral" | "orange"
}

export const contactMethodChannelToggleOptions = [
  { value: "active", label: "Erlaubt" },
  { value: "inactive", label: "Verboten" },
]

export const contactMethodKindLabel = (kind: PublicContactMethodKind | string): string => {
  const normalized = kind.toUpperCase()

  if (normalized === "EMAIL") return "E-Mail-Adresse"

  if (normalized === "MOBILE") return "Mobilnummer"

  if (normalized === "FIXED_LINE") return "Festnetznummer"

  if (normalized === "ADDRESS") return "Postanschrift"

  return "Kontaktmittel"
}

export const channelActionLabel = (
  method: PublicContactMethodResponse,
  channel: PublicContactMethodChannel,
): string => {
  const normalizedKind = method.kind.toUpperCase()
  const normalizedChannel = channel.toUpperCase()
  const isPhone = normalizedKind === "MOBILE" || normalizedKind === "FIXED_LINE"

  if (normalizedKind === "EMAIL" && normalizedChannel === "EMAIL")
    return "Keine E-Mail mehr an diese Adresse"

  if (normalizedKind === "MOBILE" && normalizedChannel === "SMS")
    return "Keine SMS/RCS mehr an diese Nummer"

  if (normalizedKind === "MOBILE" && normalizedChannel === "WHATSAPP")
    return "Kein WhatsApp mehr an diese Nummer"

  if (normalizedKind === "MOBILE" && normalizedChannel === "MOBILE_MESSAGE") {
    return "Keine Mobile Nachricht mehr an diese Nummer"
  }

  if (isPhone && normalizedChannel === "PHONE") return "Keine Anrufe mehr an diese Nummer"

  if (normalizedKind === "ADDRESS" && normalizedChannel === "LETTER")
    return "Keine Briefe mehr an diese Adresse"

  return `${channel} abbestellen`
}

export const channelDisplayLabel = (
  method: PublicContactMethodResponse,
  channel: PublicContactMethodChannel,
): string => {
  const normalizedKind = method.kind.toUpperCase()
  const normalizedChannel = channel.toUpperCase()
  const isPhone = normalizedKind === "MOBILE" || normalizedKind === "FIXED_LINE"

  if (normalizedKind === "EMAIL" && normalizedChannel === "EMAIL") return "Kontakt per E-Mail"

  if (normalizedKind === "MOBILE" && normalizedChannel === "SMS") return "Kontakt per SMS/RCS"

  if (normalizedKind === "MOBILE" && normalizedChannel === "WHATSAPP") return "Kontakt per WhatsApp"

  if (normalizedKind === "MOBILE" && normalizedChannel === "MOBILE_MESSAGE") {
    return "Kontakt per Mobiler Nachricht"
  }

  if (isPhone && normalizedChannel === "PHONE") return "Kontakt per KI Anruf"

  if (normalizedKind === "ADDRESS" && normalizedChannel === "LETTER") return "Briefpost"

  return channel
}

export const contactMethodStatusPresentation = (
  method: PublicContactMethodResponse,
): ContactMethodStatusPresentation => {
  if (method.is_pending) {
    return { label: "Neu angegeben", color: "orange" }
  }

  if (method.deletion_requested) {
    return { label: "Löschung angefragt", color: "orange" }
  }

  if (method.channels.length && method.channels.every((channel) => !channel.is_enabled)) {
    return { label: "Kontakt verboten", color: "neutral" }
  }

  return { label: "Kontakt erlaubt", color: "green" }
}
